export const tr = {
    campaign: 'Kampanya',
    group: 'Group',
    'minus-phrases-per-group': 'Grup için negatif anahtar sözcük grupları',
    'not-specified': 'Belirsiz',
    region: 'Bölge'
};
